<div class="center wrap-x wrap-l">
    <href [link]="component.url">
        <div class="w-12-s"
             [ngClass]="[component.component_width === 'fixed' ? 'w-10' : 'w-12']">
            @if(component.image) {
            <img class="w-12"
                 [dfImage]="component.image"
                 [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                 [ratio]="client.isS ? '3/4' : '3/2'">
            }
            <div class="bg-col-w m-r m-l z-2 pos-relative"
                 [style.margin-top]="client.isS ? '-4em' : '-6em'">
                <div class="text center p1 m-t bg-col-w m-r m-l z-2 p-a"
                     *iCms="'copy' of component; content: 'html'"></div>
            </div>
        </div>
    </href>
</div>